import apiClient from '../../api';
import { handleError } from '../../utils/errorHandler';

export const markAttendance = async (type, note = "") => {
  try {
    const response = await apiClient.post('/attendance/mark', { type, note });
    return response.data;
  } catch (error) {
    handleError(error, "Error al registrar asistencia.");
    throw error;
  }
};

export const adminMarkAttendance = async (logData) => {
  try {
    const response = await apiClient.post('/attendance/admin/mark', logData);
    return response.data;
  } catch (error) {
    handleError(error, "Error al registro administrativo.");
    throw error;
  }
};

export const getMyStatus = async () => {
  try {
    const response = await apiClient.get('/attendance/my-status');
    return response.data;
  } catch (error) {
    console.error("Error al obtener estado de asistencia:", error);
    return { status: 'out' };
  }
};

export const getAllLogs = async (startDate = null) => {
  try {
    const params = startDate ? { start_date: startDate } : {};
    const response = await apiClient.get('/attendance/logs', { params });
    return response.data;
  } catch (error) {
    handleError(error, "Error al cargar historial de asistencia.");
    throw error;
  }
};

export const getShifts = async (startDate = null) => {
  try {
    const params = startDate ? { start_date: startDate } : {};
    const response = await apiClient.get('/attendance/shifts', { params });
    return response.data;
  } catch (error) {
    handleError(error, "Error al cargar turnos.");
    throw error;
  }
};

export const createShift = async (shiftData) => {
  try {
    const response = await apiClient.post('/attendance/shifts', shiftData);
    return response.data;
  } catch (error) {
    handleError(error, "Error al crear turno.");
    throw error;
  }
};

export const deleteShift = async (id) => {
  try {
    await apiClient.delete(`/attendance/shifts/${id}`);
  } catch (error) {
    handleError(error, "Error al eliminar turno.");
    throw error;
  }
};

export const getAttendanceUsers = async (limit = 1000) => {
  try {
    const response = await apiClient.get('/users/', { params: { limit } });
    return response.data;
  } catch (error) {
    handleError(error, "Error al cargar trabajadores.");
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await apiClient.put(`/users/${userId}/`, userData);
    return response.data;
  } catch (error) {
    handleError(error, "Error al actualizar usuario.");
    throw error;
  }
};

export const authorizeOvertime = async (logId, authorized) => {
  try {
    const response = await apiClient.put(`/attendance/logs/${logId}/authorize`, null, {
      params: { authorized }
    });
    return response.data;
  } catch (error) {
    handleError(error, "Error al autorizar sobretiempo.");
    throw error;
  }
};

// NUEVO: Para editar manualmente la hora de una marcación
export const updateAttendanceLog = async (logId, updateData) => {
  try {
    const response = await apiClient.put(`/attendance/logs/${logId}`, updateData);
    return response.data;
  } catch (error) {
    handleError(error, "Error al corregir el horario.");
    throw error;
  }
};

export const createManualShift = async (manualData) => {
  try {
    const response = await apiClient.post('/attendance/admin/manual-shift', manualData);
    return response.data;
  } catch (error) {
    handleError(error, "Error al crear turno manual.");
    throw error;
  }
};
